import { getStatsFromQrCodeData } from '~/components/organisms/previewBar/model-data/utils';
import { appsSlice } from '~/store/reducers/previewScreens/apps';
import { imagesSlice } from '~/store/reducers/previewScreens/images';
import { listOfLinksSlice } from '~/store/reducers/previewScreens/list-of-links';
import { pdfSlice } from '~/store/reducers/previewScreens/pdf';
import { socialMediaSlice } from '~/store/reducers/previewScreens/social-media';
import { vCardPlusSlice } from '~/store/reducers/previewScreens/vcard-plus';
import { websiteSlice } from '~/store/reducers/previewScreens/website';
import { qrCodeSlice } from '~/store/reducers/qr-code';
import { getFullAddressName } from '~/utils/google-maps/adress';

export const previewModelData = {
  website: (data, dispatch, micrositeEditData) => {
    const actions = websiteSlice.actions;
    const qrCodeActions = qrCodeSlice.actions;

    dispatch(
      actions.setRenderedMicrositeData({
        title: micrositeEditData?.title,
        websiteInformation: data?.url,
        stats: getStatsFromQrCodeData(micrositeEditData),
      }),
    );
    dispatch(qrCodeActions.setData(micrositeEditData));
  },
  links: (data, dispatch, micrositeEditData) => {
    const actions = listOfLinksSlice.actions;
    const qrCodeActions = qrCodeSlice.actions;

    const {
      selectedTemplate,
      design,
      fonts: { descriptionSize, socialMediaSize, titleSize, text, title },
      logo: { borderRadius, logo, rotate, scale },
      coverImage,
      description,
      imagesViewType,
      socials,
      images,
      links,
    } = data;

    dispatch(actions.setFonts({ field: 'text', value: text }));
    dispatch(actions.setFonts({ field: 'title', value: title }));
    dispatch(actions.setImages(images));
    dispatch(actions.setImagesType(imagesViewType));
    dispatch(actions.setSelectedTemplate(selectedTemplate));
    dispatch(actions.setBackgroundColor([...Object.values(design)]));
    dispatch(actions.setBasicInformation({ field: 'h1', value: data.title }));
    dispatch(actions.setBasicInformation({ field: 'h2', value: description }));
    dispatch(actions.setFontsSize({ field: 'descriptionSize', value: descriptionSize }));
    dispatch(actions.setFontsSize({ field: 'socialMediaSize', value: socialMediaSize }));
    dispatch(actions.setFontsSize({ field: 'titleSize', value: titleSize }));
    dispatch(actions.setBasicInformation({ field: 'coverImage', value: { url: coverImage } }));
    dispatch(
      actions.setContentLinkList(
        links.map((item) => ({
          previewLink: item?.photo,
          url: item?.url,
          linkText: item?.text,
          id: `UNIQUE_ID_${item?.id}`,
          unique_id: item?.id,
        })),
      ),
    );
    dispatch(actions.setSocialLinks(socials.map((item) => ({ ...item, value: item.url }))));

    dispatch(actions.setStatsData(getStatsFromQrCodeData(micrositeEditData)));

    dispatch(actions.setBasicInformation({ field: 'logoImage', value: { url: logo, scale, borderRadius, rotate } }));
    dispatch(actions.setMicrositeData(micrositeEditData?.microsite));

    if (!micrositeEditData) {
      dispatch(actions.setMicrositeStyles({ container: { borderRadius: 0, margin: 0, height: '100vh' } }));
    } else {
      dispatch(qrCodeActions.setData(micrositeEditData));
    }
  },

  images: (data, dispatch, micrositeEditData) => {
    const actions = imagesSlice.actions;
    const qrCodeActions = qrCodeSlice.actions;

    const { title, design, fonts, images, imagesViewType, description, website, buttons } = data;

    dispatch(
      actions.setRenderedMicrositeData({
        bacgkroundColor: [design?.primary],
        fonts,
        images,
        imagesType: imagesViewType,
        imageInformation: {
          header: title,
          description,
          website,
        },
        buttons,
        micrositeData: micrositeEditData?.microsite,
        stats: getStatsFromQrCodeData(micrositeEditData),
      }),
    );

    if (!micrositeEditData) {
      dispatch(actions.setMicrositeStyles({ container: { borderRadius: 0, margin: 0, height: '100vh' } }));
    } else {
      dispatch(qrCodeActions.setData(micrositeEditData));
    }
  },

  app: (data, dispatch, micrositeEditData) => {
    const actions = appsSlice.actions;
    const qrCodeActions = qrCodeSlice.actions;

    const { developer, name, description, logo, app, design, website, fonts } = data;

    dispatch(
      actions.setRenderedMicrositeData({
        fonts,
        bacgkroundColor: [design?.primary],
        appInformation: {
          appName: name,
          developerCompany: developer,
          description,
          website,
        },
        platformLinks: {
          google: app?.android,
          apple: app?.iphone,
        },
        logo: { path: logo },
        micrositeData: micrositeEditData?.microsite,
        stats: getStatsFromQrCodeData(micrositeEditData),
      }),
    );

    if (!micrositeEditData) {
      dispatch(actions.setMicrositeStyles({ container: { borderRadius: 0, margin: 0, height: '100vh' } }));
    } else {
      dispatch(qrCodeActions.setData(micrositeEditData));
    }
  },

  pdf: (data, dispatch, micrositeEditData) => {
    const actions = pdfSlice.actions;
    const qrCodeActions = qrCodeSlice.actions;

    const {
      selectedTemplate,
      coverImage,
      description,
      website,
      title,
      design,
      pdfs,
      fonts,
      company,
      button,
      directPdfLink,
    } = data;

    dispatch(
      actions.setRenderedMicrositeData({
        selectedTemplate,
        bacgkroundColor: [design['primary'], design['secondary']],
        fonts: {
          head: fonts?.titleFont,
          text: fonts?.textFont,
        },
        basicInformation: {
          isFileUpload: directPdfLink,
          coverImage: { img: coverImage },
          images: pdfs.map((item) => ({
            previewLink: item.previewImage,
            previewPdfLink: item.file,
            size: item.size,
            path: item.name,
            name: item.name,
            description: item.description,
            id: `UNIQUE_ID_${item?.id}`,
            unique_id: item?.id,
          })),
        },
        pdfInformation: {
          company,
          title,
          description,
          website,
          button,
        },
        micrositeData: micrositeEditData?.microsite,
        stats: getStatsFromQrCodeData(micrositeEditData),
      }),
    );

    if (!micrositeEditData) {
      dispatch(actions.setMicrositeStyles({ container: { borderRadius: 0, margin: 0, height: '100vh' } }));
    } else {
      dispatch(qrCodeActions.setData(micrositeEditData));
    }
  },

  ['social-media']: (data, dispatch, micrositeEditData) => {
    const actions = socialMediaSlice.actions;
    const qrCodeActions = qrCodeSlice.actions;

    const { description, title, design, socials, fonts } = data;

    dispatch(
      actions.setRenderedMicrositeData({
        bacgkroundColor: [design?.primary],
        fonts,
        appInformation: {
          head: title,
          description,
        },
        socialLinks: socials.map((item) => ({ ...item, value: item.url })),
        micrositeData: micrositeEditData?.microsite,
        stats: getStatsFromQrCodeData(micrositeEditData),
      }),
    );

    if (!micrositeEditData) {
      dispatch(actions.setMicrositeStyles({ container: { borderRadius: 0, margin: 0, height: '100vh' } }));
    } else {
      dispatch(qrCodeActions.setData(micrositeEditData));
    }
  },
  ['vcard-plus']: (data, dispatch, micrositeEditData) => {
    const actions = vCardPlusSlice.actions;
    const qrCodeActions = qrCodeSlice.actions;

    const {
      selectedTemplate,
      design,
      fonts,
      person,
      personTitle,
      coverImage,
      phones,
      emails,
      websites,
      location,
      summary,
      imagesViewType,
      images,
      companies,
      socials,
      header,
      footer,
      contactStorageOption,
      socialsTitle,
      contactAddBtnOnTheTop,
      contactAddBtnFloatingButton,
      id,
    } = data;

    const footerType = () => {
      if (contactAddBtnOnTheTop) return 'top';
      if (contactAddBtnFloatingButton) return 'floating';

      return null;
    };

    dispatch(
      actions.setRenderedMicrositeData({
        micrositeId: id,
        selectedTemplate,
        bacgkroundColor: [design['primary'], design['secondary']],
        fonts: {
          title: fonts?.text,
          text: fonts?.title,
        },
        basicInformation: {
          name: person?.firstName,
          surName: person?.lastName,
          titleValue: person?.title,
          titlePosition: personTitle === 'CENTERED' ? 'center' : personTitle.toLowerCase(),
          logoImage: {
            url: person?.photo?.logo,
            scale: person?.photo?.scale,
            borderRadius: person?.photo?.borderRadius,
            rotate: person?.photo?.rotate,
          },
          coverImage: {
            url: coverImage,
          },
          contactInfo: {
            phone: phones.map((item) => ({ type: item?.type, label: item?.title, value: item?.phone })),
            email: emails.map((item) => ({ label: item?.title, value: item?.email })),
            website: websites.map((item) => ({ label: item?.title, value: item?.url })),
          },
          location: {
            type: location?.type,
            address: getFullAddressName(location),
            street: location?.street,
            number: location?.number,
            postalCode: location?.postalCode,
            city: location?.city,
            state: location?.state,
            country: location?.country,
            url: location?.url || '',
            latitude: location?.latitude,
            longitude: location?.longitude,
            locationOption: location?.locationVisibility,
          },
          summary,
        },
        content: {
          images,
          imagesType: imagesViewType,
          companies: companies?.map((item, index) => ({
            id: index + 1,
            name: item?.name,
            profession: item?.profession,
            unique_id: item?.id,
          })),
          socialLinks: socials.map((item) => ({ ...item, value: item.url })),
          headerPhone: header?.headerPhone,
          headerLocation: header?.headerLocation,
          headerEmail: header?.headerEmail,
          footerTitle: footer,
          footerType: footerType(),
          contactOptions: contactStorageOption,
          socialTitle: socialsTitle,
        },
        micrositeData: micrositeEditData?.microsite,
        stats: getStatsFromQrCodeData(micrositeEditData),
      }),
    );

    if (!micrositeEditData) {
      dispatch(actions.setMicrositeStyles({ container: { borderRadius: 0, margin: 0, height: '100vh' } }));
    } else {
      dispatch(qrCodeActions.setData(micrositeEditData));
    }
  },
};
